import styled, { css } from 'styled-components';

import {
  scale110,
  spaceM,
  xdlPalettePetrol03,
  xdlPalettePetrol08,
} from '@xing-com/tokens';

const videoUiElements = css`
  & .vjs-poster {
    background-color: transparent;

    img {
      width: 100%;
    }
  }

  & .vjs-button > .vjs-icon-placeholder::before {
    font-size: ${scale110};
    line-height: 2.66em;
  }

  & .vjs-slider {
    background-color: rgba(255, 255, 255, 0.25);
  }

  & .vjs-slider {
    border-radius: 1em;
    height: 0.5em;
  }

  & .vjs-slider-bar {
    border-radius: 1em;
  }

  & .vjs-audio-button {
    display: none;
  }

  & .vjs-seek-to-live-control {
    display: none;
  }
`;
const subtitles = css`
  & .vjs-text-track-display > div > div > div {
    background-color: rgba(0, 0, 0, 0.69) !important;
    border-radius: 8px;
    display: inline-block !important;
    font-family: 'Fira Sans', 'Trebuchet MS', Verdana, sans-serif !important;
    padding: 0.5em;
    text-shadow: none;
  }
`;
const bigPlayButton = css`
  & .vjs-big-play-button {
    background-color: ${xdlPalettePetrol08};
    border: 0;
    border-radius: 50%;
    color: white;
    display: block;
    font-size: 64px;
    height: 96px;
    left: calc(50% - 96px / 2);
    top: calc(50% - 96px / 2);
    width: 96px;

    &:hover,
    &:focus {
      background-color: inherit;
    }
  }

  & .vjs-big-play-button .vjs-icon-placeholder::before,
  & .vjs-play-control .vjs-icon-placeholder::before,
  & .vjs-icon-play::before {
    padding-left: 0.1em;
  }

  &.vjs-has-started.vjs-paused
    .vjs-big-play-button
    .vjs-icon-placeholder::before,
  &.vjs-play-control.vjs-paused .vjs-icon-placeholder::before {
    padding-left: 0;
  }

  &.vjs-has-started .vjs-big-play-button.xing-vjs-changing-status {
    display: block;
  }

  &:hover .vjs-big-play-button {
    background-color: ${xdlPalettePetrol08};
  }

  &.vjs-has-started .vjs-big-play-button {
    background-color: black;
    display: none;
    opacity: 0;
  }

  &.vjs-playing .vjs-big-play-button.xing-vjs-changing-status {
    animation: xing-flip-video-status 0.5s;
    & .vjs-icon-placeholder::before {
      content: '\f101';
    }
  }

  &.vjs-paused .vjs-big-play-button.xing-vjs-changing-status {
    animation: xing-flip-video-status 0.5s;
    & .vjs-icon-placeholder::before {
      content: '\f103';
    }
  }
`;
const progressBar = css`
  & .vjs-load-progress,
  & .vjs-load-progress div {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 1em;
  }

  & .vjs-progress-control {
    bottom: 6.4em;
    height: 0.7em;
    left: 0;
    position: absolute;
    width: 100%;
  }

  & .vjs-progress-control .vjs-mouse-display .vjs-time-tooltip,
  & .vjs-play-progress .vjs-time-tooltip {
    display: none;
    opacity: 0;
  }

  & .vjs-progress-control .vjs-progress-holder {
    margin: 0 26px;
  }
`;
const controlBar = css`
  & .vjs-subs-caps-button {
    display: none;
  }

  &.xing-vjs-menu-visible video {
    opacity: 0.7;
  }

  & .vjs-control-bar {
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.8) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    box-sizing: content-box;
    height: 6.4em;
    padding-top: calc(50% * 9 / 16 - 6.4em);
    pointer-events: none;
  }

  & .vjs-control {
    pointer-events: auto;
  }

  & .vjs-play-control {
    /* change this when we have an svg for the play and pause buttons */
    margin-left: calc(26px - 1.3em);
  }

  & .vjs-fullscreen-control {
    margin-right: calc(26px - 0.7em);
  }
`;
const timer = css`
  & .vjs-time-control {
    font-size: 1.6em;
    line-height: 4em;
    padding-left: 0.5em;
  }

  & .vjs-current-time {
    padding-right: 0;
  }

  & .vjs-duration {
    display: flex;
    flex: 1;
    padding-left: 0;
    text-align: left;
  }

  & .vjs-time-divider {
    min-width: 0;
    padding: 0 6px;
  }

  & .vjs-remaining-time {
    display: none;
  }
  & .vjs-time-divider,
  & .vjs-current-time,
  & .vjs-duration {
    display: block;
  }

  & .vjs-fullscreen-control .vjs-icon-placeholder {
    background: url("data:image/svg+xml;utf8,<svg width='29' height='20' xmlns='http://www.w3.org/2000/svg'><g fill='#FFF' fill-rule='nonzero'><path d='M2 18h7a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v4zM27 2h-7a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V2zM27 18h-7a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1v-5a1 1 0 0 0-2 0v4zM2 2h7a1 1 0 1 0 0-2H1a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V2z'/></g></svg>");
  }
`;
const volume = css`
  & .vjs-volume-panel .vjs-mute-control {
    padding: 0;
  }

  & .vjs-volume-tooltip {
    margin-top: ${spaceM};
  }

  &
    .vjs-volume-panel
    .vjs-volume-control.vjs-volume-control.vjs-volume-horizontal,
  &
    .vjs-volume-panel.vjs-hover
    .vjs-volume-control.vjs-volume-control.vjs-volume-horizontal {
    height: auto;
    margin: 0;
  }

  & .vjs-volume-panel.vjs-volume-panel-horizontal:hover,
  & .vjs-volume-panel.vjs-volume-panel-horizontal {
    width: auto;
  }

  &
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-mute-control:hover
    ~ .vjs-volume-control.vjs-volume-horizontal,
  &
    .vjs-control-bar
    .vjs-volume-panel
    .vjs-volume-control.vjs-volume-horizontal {
    height: 100%;
  }

  & .vjs-volume-control.vjs-volume-horizontal {
    align-items: center;
    position: relative;

    & .vjs-volume-bar {
      margin: 0;
      position: relative;
    }
  }

  & .vjs-slider-horizontal .vjs-volume-level {
    height: 100%;
  }

  /* slider bars - progress and volume */
  & .vjs-play-progress::before,
  & .vjs-volume-level::before {
    align-items: center;
    bottom: 0;
    color: ${xdlPalettePetrol03};
    display: flex;
    top: 0;
  }

  /* slider bar - left of circle */
  & .vjs-play-progress,
  & .vjs-volume-level {
    background-color: ${xdlPalettePetrol08};
    border-radius: 1em;
  }
`;
const animations = css`
  @keyframes xing-flip-video-status {
    0% {
      opacity: 1;
      transform: scale(0.5);
    }
    90% {
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }

  /* Small layout */
  .layout-tiny {
    & .vjs-time-control {
      display: none;
    }

    & .vjs-volume-panel {
      flex: 1;
    }
  }

  .layout-tiny,
  .layout-small {
    & .vjs-volume-control.vjs-volume-horizontal {
      display: none;
    }

    & .vjs-duration {
      flex: 1;
    }
  }
`;

export const VJSXing = styled.div<{ $isStory?: boolean }>`
  & {
    background-color: transparent;
    overflow: hidden;
  }

  &,
  & input,
  & textarea,
  & select,
  & button {
    font-family: 'Fira Sans', 'Trebuchet MS', Verdana, sans-serif;
    outline: 0;
  }

  & .xing-vjs-menu {
    & button {
      width: auto;
    }
  }

  & .video-js {
    ${videoUiElements}
    ${subtitles}
    ${bigPlayButton}
    ${progressBar}
    ${controlBar}
    ${timer}
    ${volume}
    ${animations}
  }

  ${({ $isStory }) =>
    $isStory &&
    css`
      & .video-js {
        padding: 0;
        height: 100vh;
      }
    `}
`;
